import DeviceMockup from 'desktop/components/device/DeviceMockup';
import { WithId } from 'commons/types/commonProps';
import { DeviceContainer } from '../device/DeviceContainer';
import Camera from '../device/Camera';
import Price from '../device/Price';
import Delivery from '../device/Delivery';
import Description from '../device/Description';

const ContributeDeviceSecond = ({ id }: WithId) => {
  return (
    <DeviceContainer id={id}>
      <DeviceMockup />
      <Camera />
      <Price />
      <Delivery />
      <Description />
    </DeviceContainer>
  );
};

export default ContributeDeviceSecond;
